<template>
    <div class="main">
        <div class="title">
            <div class="name">专家领域</div>
            <div class="btn" @click="centerDialogVisible = true, id = '',ruleForm.name = '',ruleForm.type = ''">领域添加
            </div>
        </div>
        <div class="listbox">
            <el-table
                :cell-style="{'text-align':'center'}"
                :data="tableData"
                :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
                border
                style="width: 100%;border-radius: 10px;">
                <el-table-column
                    label="分类"
                    prop="cate_name">
                </el-table-column>
                <el-table-column
                    label="领域"
                    prop="name">
                </el-table-column>
                <el-table-column
                    label="添加时间"
                    prop="create_time"
                    width="280">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button
                            v-if="Number(scope.row.delBtn) === 0"
                            class="del"
                            disabled
                            round
                            size="small">删除
                        </el-button>
                        <el-button
                            v-else
                            class="del"
                            round
                            size="small"
                            @click="handleDelete(scope.row.id)">删除
                        </el-button>
                        <el-button
                            class="edit"
                            round
                            size="small"
                            type="primary"
                            @click="centerDialogVisible = true, id = scope.row.id, ruleForm.name = scope.row.name, ruleForm.type = scope.row.cate || ''">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            :visible.sync="centerDialogVisible"
            center
            custom-class="field"
            width="400px">
            <div slot="title" class="titleDialog">
                {{ id === '' ? '添加领域' : '编辑领域' }}
            </div>
            <div>
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-position="top">
                    <el-form-item label="分类" prop="type">
                        <el-select style="width: 100%" v-model="ruleForm.type" placeholder="请选择分类">
                            <el-option v-for="item in cate_lists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="领域名称" prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button
            class=""
            round
            @click="centerDialogVisible = false">取 消</el-button>
        <el-button round type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
import {catelist, field, fieldDel, fieldlist} from "@/api/index";
// import {zhDate} from '@/utils/utils'
export default {
    name: "field",
    data() {
        return {
            id: '',
            cate_lists:[],
            centerDialogVisible: false,
            ruleForm: {
                name: '',
                type: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入领域名称', trigger: 'blur'}
                ],
                type: [
                    {required: true, message: '请选择分类', trigger: 'change'}
                ]
            },
            tableData: []
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    created() {
        this.$emit("setActive", {
            active: 1,
            act: 0,
            name: '专家管理 > 专家领域'
        })
        this.init()
        this.list()
    },
    methods: {
        async init() {
            let _data = await catelist(
                this.user.mid,
                1,
                999
            )
            this.cate_lists = _data.data
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.Field()
                } else {
                    this.$message.error('请填写！');
                    return false;
                }
            });
        },

        handleDelete(id) {
            this.id = id
            this.$confirm('此操作将删除该领域，是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 删除
        async del() {
            let _res = await fieldDel(
                this.user.mid,
                this.id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg)
                this.list()
            } else {
                this.$message.error(_res.msg)
            }
        },

        // 添加 编辑
        async Field() {
            let _res = await field(
                this.user.mid,
                this.ruleForm.name,
                this.ruleForm.type,
                this.id
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg)
                this.centerDialogVisible = false
                this.list()
            } else {
                this.$message.error(_res.msg)
            }
        },

        // 领域列表
        async list() {
            let _res = await fieldlist(
                this.user.mid,
                1,
                999
            );
            if (_res.status === 200) {
                this.tableData = _res.data
            } else {
                this.$message.error(_res.msg)
            }
        }


    },
    watch: {
        id() {
            console.log(this.id)
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>

.titleDialog {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
}

.dialog-footer button {
    width: 120px;
    height: 40px;
    border-radius: 20px;
    padding: 0;
    line-height: 40px;
    margin: 0 30px;
}

.del {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    border: solid 1px #0a2240;
    line-height: 28px;
    padding: 0;
    color: #0a2240;
}

.edit {
    width: 70px;
    height: 30px;
    background-color: #0a2240;
    line-height: 30px;
    padding: 0;
    border-radius: 15px;
}

.main {
    display: flex;
    flex-direction: column;

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px 15px 8px;

        .name {
            font-size: 20px;
            color: #ffffff;
            font-weight: bold;
        }

        .btn {
            width: 120px;
            height: 40px;
            background-color: #ff9600;
            border-radius: 20px;
            font-size: 16px;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
        }
    }

    .listbox {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 15px;
        min-height: 600px;
        flex: 1;
    }
}
</style>


